import {
  SyncOutlined,
  CheckCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import { useAppTranslation } from "~/hooks/useAppTranslation";
import * as APITypes from "~/API";

export const EntityStatusTag = ({
  status,
}: {
  status: APITypes.UnitStatusType | APITypes.BuildingStatusType;
}) => {
  const { t } = useAppTranslation();
  let color = "grey";
  let icon = <SyncOutlined />;
  let statusText = t("None");

  if (status === APITypes.UnitStatusType.Occupied) {
    color = "green";
    icon = <CheckCircleOutlined />;
    statusText = t("Occupied");
  }
  if (status === APITypes.UnitStatusType.Renovation) {
    color = "yellow";
    icon = <StopOutlined />;
    statusText = t("Renovation");
  }
  if (status === APITypes.UnitStatusType.Vacant) {
    color = "blue";
    icon = <SyncOutlined />;
    statusText = t("Vacant");
  }

  return (
    <Tag color={color} icon={icon}>
      {statusText}
    </Tag>
  );
};
